export const AUTH_TYPE = {
  EMAIL: 'email',
  PHONE: 'phone',
  QUICK_SIGNUP: 'quick_signup',
  MAGIC_LINK: 'magic_link',
  GOOGLE: 'google',
  FACEBOOK: 'facebook',
  MODAL_SIGNUP: 'modal_signup',
  OTP: 'otp',
};
